import React from 'react';
import { IPaymentMethods } from '@components/Sura/Stepper/PaymentMethods/types';
import { Grid } from '@material-ui/core';
import useStyles from '@components/Sura/Stepper/styles';
import useStore from '@hooks/useStore';

import PaymentMethodCard from '@components/Sura/PaymentMethodCard';
import PAY_ON_LINE from '@assets/images/pay_on_line.png';
import REFERENCED_PAYMENT from '@assets/images/referenced_payment.png';
import LINK_PAYMENT from '@assets/images/link_payment.png';
import { PaymentMethod } from '@store/sura';
import { observer } from 'mobx-react';
import { validationPaymentMethod } from '@utils/suraValidation';
const limitAmount = 200000;

const PaymentMethods: React.FC<IPaymentMethods> = () => {
  const { links, ui } = useStore();
  const { paymentMethods } = links.paymentConfig;
  const css = useStyles({ isMobile: ui.isMobileScreen });
  const isUSD = links.paymentLink.exchangeRate === 'USD';
  return (
    <>
      <label className={css.labelPayment}>
        Selecciona tu <span className={css.labelExtraBold}>Forma de Pago</span>
      </label>
      <Grid className={css.divCards} container spacing={ui.isMobileScreen ? 0 : 3}>
        {!isUSD && Number(links.paymentLink.total) < limitAmount && (
          <Grid xs={ui.isMobileScreen ? 12 : 4}>
            <PaymentMethodCard
              imageSrc={PAY_ON_LINE}
              paymentMethod={'Pago en línea'}
              description={'Pago con tarjeta de crédito o débito.'}
              disabled={
                validationPaymentMethod(paymentMethods.card) &&
                validationPaymentMethod(paymentMethods.directDebit)
              }
              paymentMethodSelected={PaymentMethod.card}
              paymentOption={''}
            />
          </Grid>
        )}
        <Grid xs={ui.isMobileScreen ? 12 : 4}>
          <PaymentMethodCard
            imageSrc={REFERENCED_PAYMENT}
            paymentMethod={'Pago referenciado'}
            description={'Pago vía transferencia electrónica o directo en el banco.'}
            paymentMethodSelected={PaymentMethod.bankReference}
            paymentOption={''}
          />
        </Grid>
        {!isUSD && Number(links.paymentLink.total) < limitAmount && (
          <Grid xs={ui.isMobileScreen ? 12 : 4}>
            <PaymentMethodCard
              imageSrc={LINK_PAYMENT}
              paymentMethod={'Envío de liga'}
              description={'Comparte con otros usuario las formas de pago disponibles.'}
              paymentMethodSelected={'send-reference'}
              paymentOption={''}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default observer(PaymentMethods);
